import React, { useEffect, useState } from "react";
import ForgotPasswordView from "./forgot-password.view";
import { useNavigate } from "react-router-dom";
import {
    GenerateOtpFormModel,
    IStep,
    ResetPasswordFormModel,
    VerifyOtpFormModel
} from "./types/forgot-password.types";
import { message } from "antd";
import toastify from "../../../common/toastify";
import { generateOtp, resetPassword, verifyOtp } from "./action/forgot-password.action";

const defaultStepsConfig: IStep = {
    active: 0,
    generation: {
        status: 'process',
        disabled: false,
    },
    verification: {
        status: 'wait',
        disabled: true,
    },
    reset: {
        status: 'wait',
        disabled: true,
    }
}

function ForgotPassword() {
    const navigate = useNavigate();

    const [step, setStep] = useState<IStep>(defaultStepsConfig);
    const [otpTimer, setOtpTimer] = useState<number>(0);
    const [passwordSessionTimer, setPasswordSessionTimer] = useState<number>(0);


    useEffect(() => {
        if (passwordSessionTimer === 0 && step.active === 2) {
            navigate('/login');
        }
    }, [passwordSessionTimer, step])

    function setTimer(duration: number, setter: React.Dispatch<React.SetStateAction<number>>) {
        setter(duration);

        const interval = setInterval(() => {
            setter((prev) => {
                if (prev <= 1) {
                    clearInterval(interval);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
    }

    async function handleOtpGeneration(formData: GenerateOtpFormModel) {
        try {
            await generateOtp(formData.email);
            message.success("OTP sent to the email-id");
            switch (step.active) {
                case 0:
                    setStep((prev: IStep) => ({
                        ...prev,
                        active: prev.active + 1,
                        generation: {
                            ...prev.generation,
                            status: 'finish'
                        },
                        verification: {
                            ...prev.verification,
                            status: 'process',
                            disabled: false
                        },
                    }))
                    break;
                case 1:
                    setStep((prev: IStep) => ({
                        ...prev,
                        verification: {
                            ...prev.verification,
                            status: 'process',
                            disabled: false
                        },
                        reset: {
                            ...prev.reset,
                            status: 'wait',
                            disabled: true,
                        }
                    }))
                    break;
            }

            setTimer(30, setOtpTimer);
        } catch (e) {
            console.log(e, 'error')
        }
    }

    async function handleOtpVerification(formData: VerifyOtpFormModel) {
        try {
            await verifyOtp(formData.email, formData.otp);
            setStep((prev: IStep) => ({
                active: step.active + 1,
                generation: {
                    status: 'finish',
                    disabled: true,
                },
                verification: {
                    ...step.verification,
                    status: 'finish',
                    disabled: true
                },
                reset: {
                    ...step.reset,
                    status: 'process',
                    disabled: false
                }
            }));
            toastify({title: "Success ", message: "OTP verified successfully", isSuccessful: true});
            setTimer(600, setPasswordSessionTimer);
        } catch (e) {
            console.log(e, 'error')
        }
    }

    async function onSubmit(formData: any) {
        switch (step.active) {
            case 0:
                // Step 1 -> OTP Generation Submit
                await handleOtpGeneration(formData);
                break;
            case 1:
                // Step 2 -> OTP Verification Submit
                await handleOtpVerification(formData);
                break;
            case 2:
                // Step 3 -> Reset Password Submit
                await handlePasswordReset(formData);
                break;
        }
    }

    function onStepChange(value: number) {
        setStep((prev: IStep) => ({
            ...prev,
            active: value,
        }));
    }


    async function handlePasswordReset(formData: ResetPasswordFormModel) {
        try {
            await resetPassword(formData.email, formData.password, formData.confirmPassword);
            toastify({
                title: "Password Updated Successfully! ",
                message: "Password updated successfully",
                isSuccessful: true
            })
            navigate("/login");
        } catch (e) {
            console.log(e, 'error')
        }
    }

    return (
        <ForgotPasswordView
            step={step}
            otpTimer={otpTimer}
            passwordSessionTimer={passwordSessionTimer}
            onStepChange={onStepChange}
            generateOtp={handleOtpGeneration}
            onSubmit={onSubmit}

        />
    )
}

export default ForgotPassword;
